<template>
  <div>
    <modal-tarea
      :listEntidades="listLigas"
      :listEstados="listEstados"
      :tarea="tareaSeleccionada"
      :accion="accion"
      @recargar="getPeticiones(estadoAux)"
    ></modal-tarea>
    <b-tabs pills>
      <b-tab title="En Espera" active @click="getPeticiones(1)">
        <b-card no-body class="p-2">
          <b-overlay :show="showLoading">
            <tabla-datos
              @openTarea="openTarea"
              @updateTarea="updateTarea"
              @deleteTarea="deleteTarea($event)"
              :listPeticiones="listPeticiones"
              :estado="estadoAux"
            ></tabla-datos
          ></b-overlay> </b-card
      ></b-tab>
      <b-tab title="En Revisión" @click="getPeticiones(2)">
        <b-card no-body class="p-2">
          <tabla-datos
            @openTarea="openTarea"
            @updateTarea="updateTarea"
            @deleteTarea="deleteTarea"
            :listPeticiones="listPeticiones"
            :estado="estadoAux"
          ></tabla-datos> </b-card
      ></b-tab>
      <b-tab title="Completada" @click="getPeticiones(3)">
        <b-card no-body class="p-2">
          <tabla-datos
            @openTarea="openTarea"
            @updateTarea="updateTarea"
            @deleteTarea="deleteTarea"
            :listPeticiones="listPeticiones"
            :estado="estadoAux"
          ></tabla-datos> </b-card
      ></b-tab>
      <b-tab title="Postergada" @click="getPeticiones(4)">
        <b-card no-body class="p-2">
          <tabla-datos
            @openTarea="openTarea"
            @updateTarea="updateTarea"
            @deleteTarea="deleteTarea"
            :listPeticiones="listPeticiones"
            :estado="estadoAux"
          ></tabla-datos> </b-card></b-tab
      ><b-tab title="Todas" @click="getPeticiones(0)">
        <b-card no-body class="p-2">
          <tabla-datos
            @openTarea="openTarea"
            @updateTarea="updateTarea"
            @deleteTarea="deleteTarea"
            :listPeticiones="listPeticiones"
            :estado="estadoAux"
          ></tabla-datos> </b-card></b-tab
    ></b-tabs>
  </div>
</template>
<script>
import {
  BTabs,
  BTab,
  BCard,
  //   BFormInput,
  //   BTable,
  //   // BFormDatepicker,
  //   // BRow,
  //   // BCol,
  BOverlay,
  // BButton,
  VBTooltip,
  //   BBadge,
  //   BPopover,
  //   cxxx
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import store from '@/store'
import ModalTarea from './ModalTarea.vue'
import apiCall from '../../utils/apiCall'
import {
  ID_CLIENTE,
  URL_ADMINISTRACION,
  USER,
  //   USER,
  //   ROLES,
  // xx
} from '../../utils/variables'
import TablaDatos from './TablaDatos.vue'

export default {
  components: {
    TablaDatos,
    BTabs,
    BTab,
    BCard,
    ModalTarea,
    // BFormInput,
    // BTable,
    // // BFormDatepicker,
    // // vSelect,
    // // BRow,
    // // BCol,
    BOverlay,
    // ModalDetalle,
    // ModalDetalleVersion,
    // BButton,
    // BBadge,
    // BPopover,
    // ModalNovedad,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const { getApi, postApi } = apiCall()
    const listLigas = ref([])
    const listEstados = ref([])
    const listPeticiones = ref([])
    const estadoAux = ref(1)
    const tareaNueva = ref({
      entidadSeleccionada: { value: ID_CLIENTE },
      estadoSeleccionada: null,
      descripcion: null,
      observacion: null,
      solicitante: `${USER().nombre} ${USER().apellido}`,
      id_peticion: null,
      archivos: [],
    })
    const showLoading = ref(false)
    const accion = ref('i')
    const tareaSeleccionada = ref({ archivos: [] })
    function openTarea() {
      tareaSeleccionada.value = { ...tareaNueva.value }
      accion.value = 'i'
      const estadoSeleccionadaAux = {
        value: 1,
        label: 'Esperando revisión',
      }
      tareaSeleccionada.value.estadoSeleccionada = estadoSeleccionadaAux
      store.commit('someVariables/UPDATE_SHOW_NEW_TAREA', true)
    }
    function updateTarea(item) {
      accion.value = 'u'
      const entidadSeleccionadaAux = {
        value: item.id_entidad,
        label: item.nombre,
      }
      const estadoSeleccionadaAux = {
        value: item.id_estado,
        label: item.estado,
      }
      item.entidadSeleccionada = entidadSeleccionadaAux
      item.estadoSeleccionada = estadoSeleccionadaAux
      item.descripcion = item.peticion
      tareaSeleccionada.value = { ...item }
      store.commit('someVariables/UPDATE_SHOW_NEW_TAREA', true)
    }

    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.nombre}`,
          value: element.id_cliente,
        }
        salida.value.push(obj)
      })
    }
    function transformEstados(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.estado}`,
          value: element.id_estado_revision,
        }
        salida.value.push(obj)
      })
    }
    async function getClientes() {
      listLigas.value = []
      listEstados.value = []
      const path = 'ApiClientes/getClientesTareas'
      const data = await getApi(URL_ADMINISTRACION, path)
      transformCampeonatos(data.data, listLigas)
      transformEstados(data.estados, listEstados)
    }
    async function getPeticiones(estado) {
      estadoAux.value = estado
      listPeticiones.value = []
      showLoading.value = true
      const path = `ApiClientes/getPeticionesIdCliente/${estado}/${ID_CLIENTE}`
      const data = await getApi(URL_ADMINISTRACION, path)
      listPeticiones.value = data.data
      showLoading.value = false
    }
    async function deleteTarea(item) {
      const path = 'ApiClientes/deleteTarea'
      const data = {
        id_tarea: item.id_peticion,
      }
      const response = await postApi(URL_ADMINISTRACION, path, data)
      if (response.flag === 'si') {
        getPeticiones(estadoAux.value)
      }
    }
    onMounted(() => {
      getClientes()
      getPeticiones(1)
    })
    return {
      openTarea,
      listLigas,
      listEstados,
      tareaSeleccionada,
      listPeticiones,
      showLoading,
      getPeticiones,
      updateTarea,
      accion,
      estadoAux,
      deleteTarea,
      USER,
    }
  },
}
</script>
